import { render, staticRenderFns } from "./MemorizeForm.vue?vue&type=template&id=68067555&scoped=true&lang=pug&"
import script from "./MemorizeForm.vue?vue&type=script&lang=js&"
export * from "./MemorizeForm.vue?vue&type=script&lang=js&"
import style0 from "./MemorizeForm.vue?vue&type=style&index=0&id=68067555&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68067555",
  null
  
)

export default component.exports